<template>
  <div>
    <div class="d-flex justify-content-between mt-5 mb-4">
      <div class="page-subtitle">Payment Methods</div>
      <div>
        <b-button
          class="btn-outlined bg-white text-dark edit-btn"
          variant="outline-secondary"
          v-show="paymentMethods.length > 0"
          @click="isEditing = !isEditing"
          >{{ isEditing ? 'Cancel' : 'Edit' }}</b-button
        >
      </div>
    </div>

    <div v-if="!loading && paymentMethods.length === 0">
      There is nothing to display.
    </div>

    <b-modal v-model="confirmDelete" title="Delete Card?" centered class="p-3">
      <p>
        Are you sure you want to permanently delete this card?
        <br />All details will be deleted.
      </p>
      <hr class="modal-divider" />
      <template v-slot:modal-footer>
        <b-button class="btn btn-secondary" @click="confirmDelete = false"
          >Cancel</b-button
        >
        <b-button variant="primary" :disabled="loading" @click="onClickDelete">
          <b-spinner small v-if="loading"></b-spinner>&nbsp;Delete
        </b-button>
      </template>
    </b-modal>

    <div v-if="loading">
      <card-shimmer
        v-for="i in 3"
        :key="i"
        width="100%"
        height="3.75em"
        :rounded="true"
        class="mb-4"
      ></card-shimmer>
    </div>

    <b-list-group v-else>
      <b-list-group-item
        class="c-pointer mb-4"
        v-for="pm in paymentMethods"
        :key="pm.id"
        :class="pm.is_default && !isEditing ? 'default-item' : ''"
        @click="!isEditing ? setDefaultCard(pm.id) : ''"
      >
        <b-img
          :src="
            require(`@/assets/icons/cards/dark/${pm.card.brand.toLowerCase()}.png`)
          "
          width="40"
          height="24"
          class="rounded-0 mr-3"
        ></b-img>
        <span class="text-capitalize">
          <!-- eslint-disable-next-line -->
          {{ `${pm.card.brand} Ending in ${pm.card.last4}` }}
        </span>
        <div class="remove-link" v-show="pm.is_default && !isEditing">
          <b-link>
            <b-icon scale="1.8" icon="check"></b-icon>
          </b-link>
        </div>
        <div
          class="remove-link"
          @click="onClickRemove(pm.id)"
          v-show="isEditing"
        >
          <b-link>Remove</b-link>
        </div>
      </b-list-group-item>
    </b-list-group>

    <b-modal
      v-model="show"
      title="Add Payment Method"
      centered
      hide-footer
      size="lg"
      content-class="px-4"
    >
      <payment-form @onSuccess="show = false" @onClose="show = false" />
    </b-modal>

    <b-row>
      <b-col md="6" sm="6">
        <b-button block type="button" variant="primary" @click="show = true">
          Add Payment Method
        </b-button>
      </b-col>
    </b-row>

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
      >Your default payment method has been changed</b-alert
    >
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PaymentForm from '@/components/forms/PaymentForm'
import CardShimmer from '@/components/shimmers/shimmer'

export default {
  components: {
    PaymentForm,
    CardShimmer
  },

  computed: {
    ...mapState({
      paymentMethods: state => state.payment.list
    })
  },

  data() {
    return {
      loading: false,
      show: false,
      confirmDelete: false,
      isEditing: false,
      current: 0,
      dismissCountDown: 0
    }
  },

  methods: {
    ...mapActions({
      getPayments: 'payment/getPayments',
      deletePayment: 'payment/deletePayment',
      setCardAsPrimary: 'payment/setCardAsPrimary'
    }),

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    onClickRemove(id) {
      this.current = id
      this.confirmDelete = true
    },

    async onClickDelete() {
      this.loading = true
      await this.deletePayment(this.current)
      this.loading = false
      this.confirmDelete = false
      this.$emit('remove', this.current)
    },

    async fetchPayments() {
      this.loading = true
      await this.getPayments()
      this.loading = false
      this.$emit('fetch', this.paymentMethods)
    },

    async setDefaultCard(id) {
      this.loading = true
      await this.setCardAsPrimary(id)
      this.fetchPayments()
      this.loading = false
      this.dismissCountDown = 3
      this.$emit('select', id)
    }
  },

  created() {
    this.fetchPayments()
  }
}
</script>

<style lang="scss" scoped>
.list-group-item {
  border-radius: 8px;
  border: 2px solid #e5e5e5;
}
.remove-link {
  position: absolute;
  right: 20px;
  margin-top: -26px;
}
.default-item {
  border: 2px solid #2c66d5;
  color: #2c66d5;
}
.edit-btn {
  width: 150px;
  padding: 10px;
}
</style>
